import { cn } from '@/lib/utils';
import { Loader2 } from 'lucide-react';

interface SpinnerProps extends React.HTMLAttributes<HTMLDivElement> {
  size?: 'default' | 'sm' | 'lg';
}

export const Spinner = ({ className, size = 'default', ...props }: SpinnerProps) => {
  return (
    <div className={cn('animate-spin text-muted-foreground', className)} {...props}>
      <Loader2
        className={cn({
          'h-4 w-4': size === 'sm',
          'h-6 w-6': size === 'default',
          'h-10 w-10': size === 'lg'
        })}
      />
      <span className="sr-only">Loading</span>
    </div>
  );
};
